import { Route, Routes } from "react-router-dom";
import SitesPage from "../../pages/module-pages/sites/SitesPage";
import NewSitePage from "../../pages/module-pages/sites/NewSitePage";
import UpdateSitePage from "../../pages/module-pages/sites/UpdateSitePage";

export default function SiteNav() {
  return (
    <Routes>
      <Route path="/" element={<SitesPage />} />
      <Route path="/new" element={<NewSitePage />} />
      <Route path="/update" element={<UpdateSitePage />} />
    </Routes>
  );
}
